import withResponsiveHOC from "components/enhancements/responsive-hoc/responsive-hoc-component";
import UsecasesGalleryTabsDesktopComponent from "./usecases-gallery-tabs-desktop-component/usecases-gallery-tabs-desktop-component";
import UsecasesGalleryTabsMobileComponent from "./usecases-gallery-tabs-mobile-component/usecases-gallery-tabs-mobile-component";
const UsecasesGalleryTabsComponent = withResponsiveHOC(UsecasesGalleryTabsDesktopComponent, UsecasesGalleryTabsMobileComponent);
export default UsecasesGalleryTabsComponent;
